import { Alert, Box } from '@mui/material';
import { Loader } from '../../../../components/Loader/Loader';
import { TearSheetsUpload } from '../../../../schemas/BulkTearsheetGeneration.schema';
import { getTearSheets } from '../../../../services/queries/MaggieTearsheetQueries';
import { LoadingStatus } from '../../../../types';
import { useAsync } from '../../../../util/hook-utils';
import { NoDataMessage2 } from '../../../CompanyProfiles/components/Messages/HelpMessage';
import { TearsheetGenerationGrid } from './TearsheetGenerationGrid';

interface TearsheetGenerationGridLoaderProps {
  refreshTrigger: number;
}

export function TearsheetGenerationGridLoader({ refreshTrigger }: TearsheetGenerationGridLoaderProps) {
  const { data, error, loading } = useAsync<TearSheetsUpload[]>(getTearSheets, {
    id: refreshTrigger.toString(),
  });

  if (loading === LoadingStatus.loading) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Loader />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ width: '100%', mt: '1rem' }}>
        <Alert severity='error'>{error}</Alert>
      </Box>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <NoDataMessage2 message='No tearsheets found. Generate some using the button above.' />
      </Box>
    );
  }

  return <TearsheetGenerationGrid data={data} />;
}
